export const POSTS_FETCH_ALL = "posts/fetch";
export const POSTS_FETCH_ID = "posts/:id";
export const POSTS_ADD_RESPONSE = "posts/";
export const POSTS_ADD_LOADING = "posts/loading";
export const POSTS_ERROR = "posts/error";
export const POSTS_UPDATE = "posts/update";
export const TAGS_FETCH_ALL = "tags/fetch";
export const CATEGORIES_FETCH_ALL = "categories/fetch";
export const CATEGORIES_CREATE = "categories/post/success";
export const CATEGORIES_CREATE_LOAD_STATUS = "create/status";
export const CATEGORIES_CREATE_ERROR = "create/error";
export const CATEGORIES_UPDATE = "category/update";
export const CATEGORIES_SET_TO_DEFAULT = "categories/default";
export const SEARCH_QUERY = "search/filter";
export const SEARCH_CATEGORY_BASED = 'search/filter/category';
